<template>
    <div class="shop-content">
        <ph-header>
            <van-icon name="arrow-left" size="20px" slot="left" @click="$router.back(-1)" />
        </ph-header>
        <div class="taikang-wrapper">
            <img src="https://m.ponhu.cn/Public/wap/bing/images/banner_Taik.png" alt="" srcset="">
            <img src="https://m.ponhu.cn/Public/wap/bing/images/banner_Taik2.png" alt="" srcset="">
            <img src="https://m.ponhu.cn/Public/wap/bing/images/banner_Taik3.png" alt="" srcset="">
            <div class="verify-form">
                <div class="verify-form-title fz28">填写保单</div>
                <van-cell-group>
                    <van-field
                        v-if="flag=='zc'"
                        v-model="formParams.orderId"
                        disabled
                        label-width='120px'
                        label="产品订单号"
                        label-class="c333"
                    />
                    <van-field
                        v-model="cardTypeZh"
                        disabled
                        clickable
                        label-width='120px'
                        label="被保险人证件类型"
                        label-class="c333"
                        placeholder="请选择证件类型"
                        @click.native="showPopup"
                    />
                    <van-field
                        v-model="formParams.cardNumber"
                        clearable
                        clickable
                        label-width='120px'
                        :disabled = 'isDisabled'
                        label-class="c333"
                        label="被保险人证件号码"
                        placeholder="请输入证件号码"
                    />
                    <van-field
                        v-model="formParams.userName"
                        clearable
                        clickable
                        label-width='120px'
                        :disabled = 'isDisabled'
                        label-class="c333"
                        label="被保险人姓名"
                        placeholder="请输入姓名"
                    />
                    <van-field
                        v-model="formParams.userTel"
                        clearable
                        clickable
                        label-width='120px'
                        type="tel"
                        :disabled = 'isDisabled'
                        label-class="c333"
                        label="被保险人电话"
                        placeholder="请输入手机号"
                    />
                </van-cell-group>
                <div class="submit-wrapper">
                    <van-button type="ponhu" round size="large" @click="submitTkOrder">提交</van-button>
                </div>
            </div>

        </div>

        <!-- 证件类型选择 -->
        <van-popup
            v-model="PopueShow"
            position="bottom"
        >
         <!-- :default-index="" -->
            <van-picker
                :columns="cardList"
                @change="onChange"
            />
        </van-popup>

    </div>
</template>

<script>
import PhHeader from '@/components/common/Header'
import { getTkOrder, saveTkOrder } from '@/api/order'
import { validatMobile, validatIdentityCard } from '@/utils/validate'
export default {
  name: 'shopTaikang',
  components: {
    PhHeader
  },
  data () {
    return {
      cardList: ['居民身份证', '护照', '军官证', '士官证', '港澳往来内地通行证', '台湾同胞往来大陆通行证', '其他'],
      PopueShow: false,
      goodsId: [],
      // 查看保单 禁用表单
      isDisabled: false,
      cardTypeZh: '居民身份证',
      isEdit: 'true',
      formParams: {
        orderId: '',
        cardType: 0,
        cardNumber: '',
        userName: '',
        userTel: ''
      },
      flag: '',
    }
  },
  computed: {
    token () {
      return this.$store.getters.token
    }
  },
  mounted () {
    let gid = this.$route.query.gid
    this.flag = this.$route.query.flag || 'zc'
    if((typeof gid == 'object') && gid.constructor == Array) {
      this.goodsId = gid;
    } else {
      this.goodsId.push(gid)
    }
    if(!this.flag == 'online') {
      this.getTkOrder()
    } else {
      var balance = this.$store.getters.onLineBalance;
      if(typeof(balance.taikangInsureInfo) != "undefined") {
        this.formParams.cardNumber = balance.taikangInsureInfo.cardNO
        this.formParams.userName = balance.taikangInsureInfo.name
        this.formParams.userTel = balance.taikangInsureInfo.phone
      }
      
    }
  },
  methods: {
    showPopup () {
      // this.PopueShow = true
    },
    getTkOrder () {
      getTkOrder({ userToken: this.token, goodsId: this.goodsId }).then(res => {
        if(res) {
          this.formParams = { 
            orderId: res.goodsNumber,
            cardNumber: res.cardNO,
            userName: res.name,
            userTel: res.phone
          }
        }
      }).catch(err => {
        this.$toast(err)
      })
    },
    submitTkOrder () {
      if(this.flag == 'online') {
        if (!validatMobile(this.formParams.userTel)) {
          this.$toast('请输入正确的手机号')
          return
        }
        if (!validatIdentityCard(this.formParams.cardNumber)) {
          this.$toast('请输入正确的身份证号')
          return
        }
        if (!this.formParams.userName) {
          this.$toast('请输入承保人姓名')
          return
        }
        let tk = {
          taikangInsureInfo: { cardNO: this.formParams.cardNumber, name: this.formParams.userName, phone: this.formParams.userTel }
        }
        this.$store.commit('SET_USER_ONLINE_BALANCE', tk)
        this.$router.back(-1)
      } else {
        let params = { 
          cardNO: this.formParams.cardNumber, 
          name: this.formParams.userName, 
          phone: this.formParams.userTel,
          userToken: this.token
        }
        saveTkOrder(params).then(res => {
          this.$router.back(-1)
        }).catch(err => {
          this.$toast(err)
        })
      }
    },
    onChange (picker, value, index) {
      this.formParams.cardNumber = index
      this.cardTypeZh = value
    },
    submit () {
      console.log(this.formParams)
    }
  }
}
</script>

<style lang="less" scoped>
.taikang-wrapper{
    background: #fff;
    padding-bottom: 50px;
}
.verify-form{

    padding: 0 24px;
    &-title{
        margin-bottom: 46px;
        padding-left:24px;
        border-left: 6px solid #FFD133;
    }
    .submit-wrapper{
        margin: 40px 0;
    }
}
</style>
